import { Transformation } from '../geometry/Transformation';
import { LonLat } from '../projection/Projection.LonLat';
import { CRSEarth } from './CRS.Earth';

export class CRSEPSG4326 extends CRSEarth {
  projection = LonLat;
  transformation = new Transformation(1 / 180, 1, -1 / 180, 0.5);
}
